import api from './base-api';
import type { ConsentStatusResponseDto, ConsentTokenResolveDto } from '@sportspredict/shared';

const consentApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// Student-side (authenticated) endpoints
		requestConsent: builder.mutation<ConsentStatusResponseDto, { parentEmail: string }>({
			query: (dto) => ({
				url: 'consent/request',
				method: 'POST',
				body: dto,
			}),
			invalidatesTags: ['ConsentStatus'],
		}),

		changeParentEmail: builder.mutation<ConsentStatusResponseDto, { parentEmail: string }>({
			query: (dto) => ({
				url: 'consent/parent-email',
				method: 'PATCH',
				body: dto,
			}),
			invalidatesTags: ['ConsentStatus'],
		}),

		getConsentStatus: builder.query<ConsentStatusResponseDto, void>({
			query: () => ({
				url: 'consent/status',
			}),
			providesTags: ['ConsentStatus'],
		}),

		// Public token-gated endpoints (for parent/guardian via email link)
		resolveConsentToken: builder.query<ConsentTokenResolveDto, string>({
			query: (token) => ({
				url: `consent/${token}`,
			}),
			extraOptions: {
				skipAuth: true,
			},
		}),

		approveConsent: builder.mutation<void, { token: string; consent: boolean }>({
			query: ({ token, consent }) => ({
				url: `consent/${token}/approve`,
				method: 'POST',
				body: { consent },
			}),
			extraOptions: {
				skipAuth: true,
			},
		}),

		declineConsent: builder.mutation<void, string>({
			query: (token) => ({
				url: `consent/${token}/decline`,
				method: 'POST',
			}),
			extraOptions: {
				skipAuth: true,
			},
		}),

		resolveRevokeToken: builder.query<ConsentTokenResolveDto, string>({
			query: (token) => ({
				url: `consent/revoke/${token}`,
			}),
			extraOptions: {
				skipAuth: true,
			},
		}),

		revokeConsent: builder.mutation<void, string>({
			query: (token) => ({
				url: `consent/revoke/${token}`,
				method: 'POST',
			}),
			extraOptions: {
				skipAuth: true,
			},
		}),
	}),
});

export default consentApi;

export const {
	useRequestConsentMutation,
	useChangeParentEmailMutation,
	useGetConsentStatusQuery,
	useResolveConsentTokenQuery,
	useApproveConsentMutation,
	useDeclineConsentMutation,
	useResolveRevokeTokenQuery,
	useRevokeConsentMutation,
} = consentApi;
